import React from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { StyledRadio } from './radio';

import { useGlobal } from '../../../contexts/Global/context';

import * as Styles from '../styles';
import * as S from './styles';

function Radio({ field, onChange, columns, ...rest }) {
    const { contrastTheme } = useGlobal();

    function handleChange(event) {
        const { value, labels } = event.target;

        const lookup = labels[0].innerText;

        if (typeof onChange === 'function') onChange({ id: field.id, value, lookup });
    }

    return (
        <Styles.FormGroup>
            {!!field.label && (
                <label htmlFor="first-radio">
                    {field.label && `${field.label} ${!field.required && !field.disabled ? ' (opcional)' : ''}`}
                </label>
            )}

            <S.ContainerRadio columns={columns} contrastTheme={contrastTheme}>
                <RadioGroup
                    id={field.id}
                    className={field.error && 'error'}
                    aria-label={field.name}
                    name={`customized-radios ${field.name}`}
                    value={field.value}
                    onChange={handleChange}
                    {...rest}
                >
                    {field.options.map((option) => (
                        <FormControlLabel
                            key={`${field.id}-${option.codigo}`}
                            name={field.id}
                            value={option.codigo}
                            control={<StyledRadio disabled={field.disabled || option.disabled} />}
                            label={<S.RadioText>{option.nome}</S.RadioText>}
                            disabled={field.disabled || option.disabled}
                        />
                    ))}
                </RadioGroup>
            </S.ContainerRadio>
            {field.error && <Styles.SpanError>{field.error}</Styles.SpanError>}
        </Styles.FormGroup>
    );
}

export default Radio;
